import React from 'react';
import { Link } from 'react-router-dom';
import StartButton from './StartButton';
import { business } from '@/content/business';

const columns = [
  {
    heading: 'Offer',
    links: [
      { label: 'Free discovery call', to: '/start' },
      { label: 'The AI Assistant Pilot', to: '/pilot' },
      { label: 'Ongoing consulting', to: '/consulting' },
    ],
  },
  {
    heading: 'Explore',
    links: [
      { label: 'Use cases', to: '/use-cases' },
      { label: 'How it works', to: '/#how-it-works' },
      { label: 'About', to: '/about' },
    ],
  },
];

const Footer = () => (
  <footer className="border-t border-rule bg-knightblack">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
        <div>
          <Link to="/" className="mb-4 inline-flex items-center gap-2 rounded-md">
            <img src="/lovable-uploads/0aa296c2-39b8-4316-97b8-2a5754cf1180.png" alt="" className="h-9 w-auto" />
            <span className="font-serif text-2xl leading-none">GoldCrusade</span>
          </Link>
          <p className="mb-6 max-w-xs text-mist">{business.tagline}</p>
          <StartButton />
        </div>

        {columns.map((col) => (
          <div key={col.heading}>
            <h2 className="meta-label mb-4">{col.heading}</h2>
            <ul className="space-y-3">
              {col.links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="font-mono text-xs uppercase tracking-[0.12em] text-mist transition-colors hover:text-softwhite"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <h2 className="meta-label mb-4">Contact</h2>
          <ul className="space-y-3 font-mono text-xs uppercase tracking-[0.08em] text-mist">
            <li>
              <a href={`mailto:${business.email}`} className="hover:text-softwhite">
                {business.email}
              </a>
            </li>
            <li>
              <a href={`tel:${business.phone.replace(/[^+\d]/g, '')}`} className="hover:text-softwhite">
                {business.phone}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-4 border-t border-rule pt-8 font-mono text-[0.7rem] uppercase tracking-[0.14em] text-mist md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} GoldCrusade. All rights reserved.</p>
        <ul className="flex gap-6">
          <li>
            <Link to="/privacy" className="hover:text-softwhite">
              Privacy
            </Link>
          </li>
          <li>
            <Link to="/terms" className="hover:text-softwhite">
              Terms
            </Link>
          </li>
        </ul>
      </div>
    </div>
  </footer>
);

export default Footer;
